import React, { useState } from "react";

export default function UploadPdf() {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleUpload = async () => {
    if (!file) {
      setMessage("Please select a PDF first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setIsLoading(true);
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL || "https://backend.modeai.io"}/knowledge-base/upload-pdf/`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          body: formData,
        }
      );

      const data = await res.json();
      if (res.ok) {
        setMessage(data.message || "Upload successful!");
      } else {
        setMessage(data.error || "Upload failed!");
      }
    } catch (err) {
      setMessage("Error uploading file.");
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#f5f5f5",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <h2 style={{ marginBottom: "20px" }}>Upload Files (PDF, TXT)</h2>

      <input
        type="file"
        accept="application/pdf"
        onChange={(e) => setFile(e.target.files[0])}
        style={{
          marginBottom: "10px",
          padding: "8px",
          border: "1px solid #ccc",
          borderRadius: "6px",
          backgroundColor: "#fff",
        }}
      />

      <button
        onClick={handleUpload}
        style={{
          backgroundColor: "#4CAF50",
          color: "white",
          border: "none",
          padding: "10px 20px",
          borderRadius: "6px",
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        {isLoading ? "Uploading..." : "Upload"}
      </button>

      {message && (
        <p style={{ marginTop: "20px", color: "#333", fontSize: "14px" }}>
          {message}
        </p>
      )}
    </div>
  );
}
